export default {
  fillForm: 'Заполните форму'
}
